import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import L0 from "../../assets/images/lembawe9/main.png";
import L1 from "../../assets/images/lembawe9/1.png";
import L2 from "../../assets/images/lembawe9/2.png";
import L3 from "../../assets/images/lembawe9/3.png";
import L4 from "../../assets/images/lembawe9/4.png";
import L5 from "../../assets/images/lembawe9/5.png";
import L6 from "../../assets/images/lembawe9/6.png";
import L7 from "../../assets/images/lembawe9/7.png";
import L8 from "../../assets/images/lembawe9/8.png";
import L9 from "../../assets/images/lembawe9/9.png";
import L10 from "../../assets/images/lembawe9/10.png";
import L11 from "../../assets/images/lembawe9/11.png";
import L12 from "../../assets/images/lembawe9/12.png";

import "./Main.scss";

export const Main = () => {
  const sliderImages = [
    L0,
    L1,
    L2,
    L3,
    L4,
    L5,
    L6,
    L7,
    L8,
    L9,
    L10,
    L11,
    L12,
  ];

  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  const nextSlide = () => {
    setIndex((current) => (current + 1) % sliderImages.length);
  };

  const previousSlide = () => {
    setIndex(
      (current) =>
        (current - 1 + sliderImages.length) % sliderImages.length
    );
  };

  useEffect(() => {
    if (paused) return;

    const interval = setInterval(() => {
      setIndex((current) => (current + 1) % sliderImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [paused, sliderImages.length]);

  return (
    <section className="artist-hero">
      <div className="artist-hero-glow artist-hero-glow-one" />
      <div className="artist-hero-glow artist-hero-glow-two" />

      <div className="artist-hero-content">
        <div className="artist-hero-copy">
          <div className="artist-eyebrow">
            MOROCCAN RAP • CULTURE • NEW GENERATION
          </div>

          <h1>
            LEMBAWE9
            <span>BUILDS CULTURE.</span>
          </h1>

          <p className="artist-hero-description">
            Ayman Ben Zarrou is a Moroccan producer, MC and music content
            creator behind <strong>Street Rap</strong> and
            <strong> LHANGAR</strong> — platforms built to discover talent,
            create culture and push Moroccan rap forward.
          </p>

          <div className="artist-hero-actions">
            <Link to="/lhangar" className="hero-primary-btn">
              Explore LHANGAR
              <span>↗</span>
            </Link>

            <Link to="/music" className="hero-secondary-btn">
              Listen to music
            </Link>
          </div>

          <div className="artist-hero-stats">
            <div>
              <strong>1.5M+</strong>
              <span>Community</span>
            </div>

            <div>
              <strong>2021</strong>
              <span>MWA Winner</span>
            </div>

            <div>
              <strong>360°</strong>
              <span>Creative Universe</span>
            </div>
          </div>
        </div>

        <div
          className="artist-hero-visual"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <div className="artist-image-frame">
            {sliderImages.map((image, imageIndex) => (
              <img
                key={imageIndex}
                src={image}
                alt={`Lembawe9 visual ${imageIndex + 1}`}
                className={
                  imageIndex === index
                    ? "artist-slide active"
                    : "artist-slide"
                }
              />
            ))}

            <div className="artist-image-overlay" />

            <div className="artist-image-label">
              <small>FEATURED</small>
              <span>LEMBAWE9</span>
            </div>

            <div className="artist-slider-controls">
              <button onClick={previousSlide} aria-label="Previous slide">
                ←
              </button>

              <div className="artist-slider-progress">
                {String(index + 1).padStart(2, "0")} /{" "}
                {String(sliderImages.length).padStart(2, "0")}
              </div>

              <button onClick={nextSlide} aria-label="Next slide">
                →
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="artist-scroll-indicator">
        <span />
        SCROLL TO DISCOVER
      </div>
    </section>
  );
};